import { render, staticRenderFns } from "./Outer.vue?vue&type=template&id=00de4c6c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Outer.vue"
export default component.exports